<template>
    <div class="box">
        <div class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl">Positions</div>
                <button class="btn btn--outline-primary btn--middle" data-dismiss="modal" data-toggle="modal"
                        data-target="#new-position"
                        @click="showCustomModal(`positions-modal`, 1)"
                >+ Add Position
                </button>
                <AddNewItemModal
                    title="Add New Position"
                    confirm-text="Save"
                    reject-text="Cancel"
                    type="select"
                    :id="getCustomModalId(`positions-modal`, 1)"
                    :positions="positionsList"
                    @confirm="addNewPosition"
                ></AddNewItemModal>

            </div>
            <div class="table-holder table-responsive">
                <table class="table table-uniform">
                    <thead>
                    <tr>
                        <th></th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="position in clientInfo.positions" :key="position.id">
                        <td>
                            <p>{{ position.title }}</p>
                        </td>
                        <td class="text-right">
                            <div class="action-block">
                                <button
                                    class="delete-link"
                                    @click="showDeleteModal(position.id)"
                                ><img src="/img/svg/on.svg" alt="delete"></button>
                                <ActionModal
                                    confirm-text="Yes"
                                    reject-text="No"
                                    :modalId="getDeleteModalId(position.id)"
                                    @confirm="deletePosition(position.id)"
                                >
                                    <template #body>
                                        <div class="text-center mb-4">
                                            <h4>
                                                Are you sure you want <br> to delete this item?
                                            </h4>
                                        </div>
                                    </template>
                                </ActionModal>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import CommonService from "../../../../AppUser/resources/js/services/CommonService";
import AddNewItemModal from "../../../../../../resources/js/components/AddNewItemModal.vue";
import SiteClientsService from "../services/SiteClientsService";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";

export default {
    name: "Positions",
    components: {ActionModal, AddNewItemModal},
    mixins: [ModalHandler],
    props: {
        clientInfo: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            positionsList: [],
        }
    },
    methods: {
        async addNewPosition(item) {
            this.$showLoadingMessage()
            if (item) {
                const found = this.clientInfo.positions.find(el => el.id === item)
                if (!found) {
                    try {
                        await SiteClientsService.addNewPosition(this.clientInfo.id, item);
                        const foundPosition = this.positionsList.find(pos => pos.id === item)
                        this.clientInfo.positions.push(foundPosition);
                        $('#positions-modal-1').modal('hide');
                        this.$showSuccessMessage('New position was added')
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    $('#positions-modal-1').modal('hide');
                    this.$showInfoSwal();
                }
            } else {
                this.$showErrorMessage('Please select the position');
            }
        },
        async deletePosition(id) {
            this.$showLoadingMessage();
            this.clientInfo.positions = this.clientInfo.positions.filter((pos) => pos.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await SiteClientsService.deletePosition(this.clientInfo.id, id)
            } catch (error) {
                this.$showErrorMessage('The position was not deleted. Please try again');
            }
        },
        async getListOfPositions() {
            try {
                const {data: positions} = await CommonService.getListOfPositions()
                this.positionsList = positions
            } catch (error) {
                this.$showErrorMessage();
            }
        },
    },
    mounted() {
        this.getListOfPositions()
    }
}

</script>

<style scoped>

</style>
